import office from '@/taskpane/officejs/office-wrapper'
import CallbackArgs from '../messages/callback-args'
import { sendItemApiDataMail } from '../messages/send-item-api-data-mail'

export interface MailItemOpenProcessedArgs extends CallbackArgs {
  id: string
  subject: string
  threadId: string
  threadIndex: string
  conversationId: string
  headerMessageId: string
}

export default async function mailItemOpenProcessedHandler(args: MailItemOpenProcessedArgs) {
  if (!office.mode.isCompose() || (args.id && (!args.threadId || !args.headerMessageId))) {
    await sendItemApiDataMail()
  }
}
